import React from "react";
import Banner from "../banner";
import { Cinematic } from "../cinematic";
import Partners from "../partners";
import Partners2 from "../partners2";
import Investors from "../investors";
import crystal from "../../assets/images/crystal-filter-1.jpeg";
export const HomePage = () => {
  return (
    <>
      <Banner />
      <Cinematic />
      <Partners />
      <Partners2 />

      <div className="brutal_main_div flex items-center justify-center h-screen text-white">
        <img className="crystal-filter" src={crystal} alt="" />
        <div class="generals-brtual"></div>
        <div class="home-page-fade-big-top"></div>
        <div class="bg-red-1"></div>
        <div class="bg-red-2"></div>
        <div class="bg-red-3"></div>
        <div class="bg-black-brtual"></div>
        <div class="content-brtual absolute w-[100%] text-[40px] md:text-[70px] xl:text-[50px]">
          BE BRUTAL. BE BRAVE.
        </div>
        <div class="play-now">
          <a href="/tournaments">
            <button className="lg:tracking-[5px] font-semibold">
              PLAY NOW
            </button>
          </a>
        </div>

        {/* ======== */}
        {/* <div className="text-center rounded-[20px] w-[75%] flex items-center justify-center ">
          <div className="">
            <div className="bg-content">
              <h1 className=" font-bold text-[35px] sm:text-[45px] md:text-[60px] mb-[15px]">
                BE BRUTAL BE BRAVE.
              </h1>
              <button
                type="button"
                className="rounded-[30px]  w-[200px] py-4 text-lg font-bold text-white bg-transparent shadow-sm ring-1 ring-inset ring-[#7C0B0B] tracking-[5px] hover:bg-black hover:ring-[black]"
              >
                PLAY NOW
              </button>
            </div>
          </div>
        </div> */}
        {/* ============== */}
      </div>
      {/* <Investors /> */}
    </>
  );
};
